import get from 'lodash/get';

export default function isEftFormModified(formData, defaultState) {
  const details = get(formData, 'paymentOption.details');

  if (details) {
    return formData.firstName !== defaultState.firstName
      || formData.lastName !== defaultState.lastName;
  }

  return formData.accountNumber !== defaultState.accountNumber
    || formData.branchNumber !== defaultState.branchNumber
    || formData.institutionNumber !== defaultState.institutionNumber
    || formData.firstName !== defaultState.firstName
    || formData.lastName !== defaultState.lastName;
}
